// extracted by mini-css-extract-plugin
var _1 = "loading-spinner__yWqoa";
export { _1 as "loadingSpinner" }
